// Function converts the given string to a numeric hash
export function getHslFromString(str, s, l) {
    var hash = 0;
    if(str) {
        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
    }

    var h = hash % 360;
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
}